export default __webpack_public_path__ + "static/media/coinTree.05d0b42f.png";